<template>
    <div class="wrap" :style="{position:(eShow1||eShow2||engDig)?'absolute':'',top:0,bottom:0,overflow:(eShow1||eShow2||engDig)?'hidden':'auto'}">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist' :style="{position:(eShow1||eShow2||engDig)?'absolute':'',top:0,bottom:0,overflow:(eShow1||eShow2||engDig)?'hidden':'auto'}">
                    <div class="blk1">
                        <img src="@/views/property/image/banner1@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                        <div class="blkps">
                            <div class="blkrect"></div>
                            <div class="txtku1">申报工单</div>
                        </div>
                    </div>
                    <div :class="{ 'mainSty': true,'fHeight':fhShow}">
                        <div class="blka">
                            <div class="txta">{{title}}</div>
                        </div>
                        <div class="blka">
                            <div class="txtb">{{code}}</div>
                        </div>
                        <div class="alSty">
                            <div class="blkb">
                                <div class="txtc"></div>
                                <div>
                                    <div class="txtd">故障类型</div>
                                </div>
                                <div class="blkc" @click="ftSelect">

                                    <div class="txte" :style="'color:'+(fType=='请选择'?'red':'')">{{fType}}</div>
                                    <div class="blkf"><img src="@/views/index/image/back@2x.png" class="imga"></img></div>
                                </div>
                            </div>
                        </div>
                        <div class="alSty">
                            <div class="blkg">
                                <div class="txtc"></div>
                                <div>
                                    <div class="txtd">事件级别</div>
                                </div>
                                <div class="blkc" @click="etSelect">
                                    <div class="txte" :style="'color:'+(eType=='请选择'?'red':'')">{{eType}}</div>
                                    <div class="blkf"><img src="@/views/index/image/back@2x.png" class="imga"></img></div>
                                </div>
                            </div>
                        </div>
                        <div class="alSty1">
                            <div class="blkg1">
                                <div class="txtc"></div>
                                <div>
                                    <div class="txtd">故障描述</div>
                                </div>
                                <div class="blkh1">
                                    <div class="txth">
                                        <div style="display:flex;flex-direction:row;flex-wrap:wrap">
                                            <div @click="cliSty(index,item)" class="mtSty" style="" v-for="(item,index) in estItem" :key="index">
                                                <div :class="{active:index==current,e_rect:true,hBorder:hType}">{{item.dictValue}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blkop" v-if="diag">
                                    <van-field v-model="message" rows="7" autosize autofocus type="textarea" maxlength="255" placeholder="说明" show-word-limit class="inpup" :style="'border-color:'+(message==''?'#707070':'')" />
                                </div>
                            </div>
                        </div>
                        <div class="eng2txt">紧急情况下请直接拨打运维人员的电话</div>
                    </div>
                    <div class="blkn">
                        <div style="flex:1;">
                            <div class="btnn">
                                <button :disabled="disabled" @click="submitBill" class="btnn">提交工单</button>
                            </div>
                            <!-- <button class="btnn"    @click="submitBill">提交工单</button> -->
                        </div>
                    </div>
                </div>
            </div>

            <div style="width:100%;height:100%;" v-if="eShow1">
                <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.99;background: #333333;">
                    <div class="dialogs">
                        <div class="imgblk" @click="close"><img src="./image/x@2x.png" class="imgtlk"></img></div>
                        <div class="digtxt" style="margin-bottom:0">故障类型</div>
                        <div class="ofSty">
                            <div v-if="failItem.length>0" class="digtxt" @click="selects(index,item)" v-for="(item,index) in failItem" :key="index">
                                <div :class="{active1:current1==index,nbtn:true}">{{item.dictValue}}</div>
                            </div>
                            <div v-else>
                                <div class="nData">暂无数据</div>
                            </div>
                        </div>
                        <div style="display:flex;align-items:center;justify-content:center">
                            <div class="submit" @click="submit">提交</div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="width:100%;height:100%" v-if="eShow2">
                <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.99;background: #333333;">
                    <div class="dialogs2">
                        <div class="digtxt1">事件级别</div>
                        <div style="display:flex;">
                            <div class="imgblk" @click="close"><img src="./image/x@2x.png" class="imgtlk"></img></div>
                            <div class="imghj" style="flex:1;">
                                <div class="rectSty">
                                    <div :class="className"></div>
                                    <div :class="className1">
                                        <div class="tRect"></div>
                                    </div>
                                </div>
                            </div>
                            <div style="flex:1">
                                <div class="digtxt2" @click="selectd(index,item)" v-for="(item,index) in dItem" :key="index">
                                    <div :style="{borderColor:color1}" :class="{active2:(current2==index),nbtn:true,nbtn1:true}">{{item.value}}</div>
                                </div>
                            </div>
                        </div>
                        <div style="display:flex;align-items:center;justify-content:center">
                            <div class="submit" @click="submit2">提交</div>
                        </div>
                    </div>

                </div>
            </div>
            <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
            <van-dialog v-model:show="engDig" title="提交成功" @cancel="closeDig" @confirm="closeDig" confirm-button-color="#108EE9" show-cancel-button>
                <div class="digtxt3">
                    <img src="../../components/image/success.png" alt="" style="width: 35%;padding-top: 25px;">
                    <div style="padding: 20px 0; color: #003cff;text-align: center;">提交成功！<br>等待工程师响应</div>
                    <!-- <van-field v-model="reasons1" style="border:1px solid #eee" rows="3" autosize type="textarea" placeholder="请输入流转原因" /> -->
                </div>
            </van-dialog>
            <!-- <div style="width:100%;height:100%" v-if="engDig">
                <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.99;background: #333333;">
                    <div class="dialogs dialogs1">
                        <div class="imgblk" @click="closeDig"><img src="./image/x@2x.png" class="imgtlk"></img></div>
                        <div class="digtxt">提交成功！<br />等待工程师响应</div>
                        <div style="display:flex;align-items:center;justify-content:center">
                            <div class="submit" @click="closeDig">确定</div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import customToast from "@/components/toast.vue";
export default {
    components: {
        customToast,
    },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            index: -1,
            title: "",
            code: "",
            diag: false,
            message: "",
            tmsg: "",
            color1: "#efefef",
            current: null,
            current1: null,
            current2: null,
            eShow1: false,
            eShow2: false,
            bSty: true,
            fType: "",
            fIndex: "",
            val1: "",
            eType: "",
            eIndex: "",
            val2: "",
            hType: false,
            fhShow: true,
            engDig: false,
            disabled: false,
            failItem: [],
            estItem: [],
            dItem: [
                {
                    id: "0",
                    value: "低",
                },
                {
                    id: "1",
                    value: "中",
                },
                {
                    id: "2",
                    value: "高",
                },
                {
                    id: "3",
                    value: "紧急",
                },
            ],
        };
    },
    created() {
        this.title = this.$route.query.name;
        this.code = this.$route.query.code;
        this.getlevelData();
        this.getDescribeData();
    },
    watch() {},
    computed: {
        className() {
            return `height${this.index + 1}`;
        },
        className1() {
            return `sRect${this.index + 1}`;
        },
    },
    methods: {
        cliSty(index, item) {
            this.current = index;
            this.tmsg = item.dictValue;
            this.hType = false;
            if (
                (item.vId || item.vId == 0) &&
                item.vId == this.estItem.length - 1
            ) {
                this.diag = true;
                this.fhShow = false;
            } else {
                this.diag = false;
                this.fhShow = true;
            }
        },
        selects(index, val) {
            this.current1 = index;
            this.val1 = val.dictValue;
            this.fIndex = val.dictId;
        },
        toIndex() {
            this.$router.push("/index");
        },
        submit() {
            this.eShow1 = 0;
            this.fType = this.val1;
        },
        submit2() {
            this.eShow2 = 0;
            this.eType = this.val2;
        },
        selectd(index, val) {
            this.current2 = index;
            if (this.current2 == 0) {
                this.color1 = "#008CFF";
            } else if (this.current2 == 1) {
                this.color1 = "#0BBCB2";
            } else if (this.current2 == 2) {
                this.color1 = "#FFBB00";
            } else if (this.current2 == 3) {
                this.color1 = "#FF0000";
            }
            this.val2 = val.value;
            this.eIndex = val.id;
            this.index = index;
        },
        close() {
            this.eShow1 = 0;
            this.eShow2 = 0;
            this.engDig = false;
        },
        ftSelect() {
            this.eShow1 = 1;
        },
        etSelect() {
            this.eShow2 = 1;
        },
        getlevelData() {
            let data = {
                dictType: 1,
                companyId: this.$store.state.user.userInfo.companyId,
            };
            this.$api
                .get("/appConfigDictData/selectConfig", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.failItem = res.data.data;
                    } else if (res.data.code == "9999") {
                        //    this.$toast(res.data.message)
                        this.toastRow = {
                            selId: 4,
                            title: res.data.message,
                            text: res.data.message,
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                });
        },
        getDescribeData() {
            let data = {
                dictType: 2,
                companyId: this.$store.state.user.userInfo.companyId,
            };
            this.$api
                .get("/appConfigDictData/selectConfig", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.estItem = res.data.data;
                        this.estItem.push({
                            vId: this.estItem.length,
                            dictValue: "其他",
                        });
                    } else if (res.data.code == "9999") {
                        //    this.$toast(res.data.message)
                        this.toastRow = {
                            selId: 4,
                            title: res.data.message,
                            text: res.data.message,
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                });
        },
        submitBill() {
            let tmsg = this.message ? this.message : this.tmsg;
            if ( this.eType && this.fType && this.eType != "请选择" && this.fType != "请选择" && tmsg ) {
                this.disabled = true;
                let data = {
                    assetsId: this.$route.query.id,
                    companyId: this.$store.state.user.userInfo.companyId,
                    createBy: this.$store.state.user.userInfo.userId,
                    maintenanceId: this.$store.state.user.userInfo.userId,
                    maintenanceName: this.$store.state.user.userInfo.name,
                    maintenanceType: 0,
                    supportDescribe: tmsg,
                    supportLevel: this.eIndex,
                    supportType: this.fIndex,
                    assetsType: this.$route.query.dictId,
                    dutyId: this.$route.query.dutyBy,
                    responseType: this.$route.query.responseType,
                };
                this.$api
                    .post("/app/support/supportRecordReport", data)
                    .then((res) => {
                        this.disabled = false;
                        if (res.data.code == "0000") {
                            this.engDig = true;
                        } else if (res.data.code == "9999") {
                            // this.$toast(res.data.message);
                            this.toastRow = {
                                selId: 4,
                                title: res.data.message,
                                text: res.data.message,
                            };
                            this.toastFlag = true;
                            setTimeout(() => {
                                this.toastFlag = false;
                            }, 1500);
                        }
                    });
            } else {
                if (!this.fType) {
                    this.fType = "请选择";
                }
                if (!this.eType) {
                    this.eType = "请选择";
                }
                if (!tmsg) {
                    this.hType = true;
                }
            }
        },
        closeDig() {
            this.engDig = false;
            this.$router.push("/index");
        },
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
.digtxt3 {
    display: flex;
    flex-direction: column;
    align-items: center;
}
button {
    border: none;
    padding: 0;
    margin: 0;
}
.nData {
    width: 100%;
    height: 95px;
    line-height: 95px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
}
.wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2002;
    overflow: auto;
    overflow-x: hidden;
    background: #e9eef2;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 100%;
}

.mainSty {
    width: 345px;
    height: 100%;
    /* padding:14px 21px; */
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    /*        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        background:#fff; */
}

/* .mtSty:nth-child(3n){ 
		margin-bottom:10px;
	}  */
.mtSty {
    margin-bottom: 10px;
    margin-right: 10px;
    display: inline-block;
}
.alSty {
    background: #fff;
    padding: 0 21px;
}
.alSty1 {
    background: #fff;
    padding: 5px 21px;
}
.ofSty {
    width: 100%;
    max-height: 350px;
    min-height: 95px;
    overflow: auto;
}
.rectSty {
    margin: 0 auto;
    width: 10px;
    height: 100%;
    border: 1px solid #0080ff;
    border-radius: 15px;
}
.hBorder {
    border: 1px solid red !important;
}
.fHeight {
    /* height:270px; */
}
.e_rect {
    /* width: 68px; */
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid #707070;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    margin: 0 auto;
    display: inline-block;
    padding: 0 5px;
}
.active {
    color: #0080ff !important;
    border: 1px solid #0080ff !important;
}
.blk1 {
    position: relative;
    width: 100%;
    height: 148px;
}
.blk1 {
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;
}
.blka {
    vertical-align: bottom;
    box-sizing: border-box;
    width: 345px;
    height: 38px;
    display: flex;
    align-items: flex-end;
    margin-bottom: 0;
    padding: 5px;
    background: #fff;
}
.txta {
    width: 200px;
    height: 28px;
    overflow: hidden;
    margin-left: 20px;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 2;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
}
.txtb {
    width: 200px;
    height: 28px;
    overflow: hidden;
    margin-left: 20px;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 1;
    font-size: 9px;
    font-weight: 400;
    color: #333333;
}
.blkb {
    position: relative;
    margin: 0 auto;
    padding: 8px 13px;
    background: #fff;
    border-bottom: 1px solid #bfbfbf;
}
.txtc {
    position: absolute;
    top: 10px;
    left: 0;
    width: 4px;
    height: 13px;
    background: #1aaeff;
}
.txtd {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
}
.blkc {
    display: flex;
    height: 22px;
    margin-top: 8px;
}
.txte {
    flex: 1;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
.blkf {
    flex: 0 0 22px;
}
.imga {
    float: left;
    width: 22px;
    height: 22px;
}
.blkg {
    position: relative;
    margin: 0 auto;
    padding: 8px 13px;
    background: #fff;
    border-bottom: 1px solid #bfbfbf;
}
.blkg1 {
    position: relative;
    margin: 0 auto;
    padding: 8px 13px;
    background: #fff;
    border-bottom: 1px solid #bfbfbf;
}
.blkh {
    display: flex;
    height: 26px;
    margin-top: 8px;
}
.blkh1 {
    display: flex;
    margin-top: 8px;
}
.txth {
    flex: 1;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
.blkn {
    display: flex;
    flex-direction: row;
    margin-top: 45px;
}
.btnn {
    width: 281px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin: 0 auto;
}
.blkps {
    position: absolute;
    top: 48px;
    right: 52px;
    width: 90px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.blkop {
    margin: 10px 10px 5px 10px;
}
.inpup {
    border: 1px solid #0080ff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
}
.mtblk {
    width: 100%;
    height: 100%;
}
.dialogs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    /* height: 490px; */
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.dialogs2 {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0 15px;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 400px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.dialogs1 {
    height: 179px;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.digtxt1 {
    width: 200px;
    height: 30px;
    font-size: 22px;
    margin: 26px auto;
    font-weight: 800;
    text-align: center;
    color: #003cff;
    line-height: 30px;
}
.digtxt2 {
    width: 200px;
    height: 56px;
    margin: 0px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 211px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
}
.eng2txt {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: #999999;
    line-height: 12px;
}
.nbtn {
    width: 211px;
    height: 42px;
    background: #eeeeee;
    border-radius: 21px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 42px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
}
.nbtn1 {
    width: 149px;
}
.active1 {
    background: #ffffff;
    border: 2px solid #008cff;
    border-radius: 21px;
    color: #008cff;
}
.active2 {
    width: 149px;
    height: 42px;
    background: #ffffff;
    border: 2px solid #0bbcb2;
    border-radius: 21px;
}
.imghj {
    width: 50px;
    height: 215px;
}
.imgblk {
    display: flex;
    position: absolute;
    top: 8px;
    right: 12px;
    width: 12px;
    height: 12px;
}
.imgtlk {
    flex: 1;
    width: 100%;
    height: 100%;
}
.height0 {
    width: 100%;
    height: 0%;
    background: green;
    border-radius: 15px;
}
.height1 {
    width: 100%;
    height: 25%;
    background: #0080ff;
    border-radius: 15px;
}
.height2 {
    width: 100%;
    height: 50%;
    background: #0bbcb2;
    border-radius: 15px;
}
.height3 {
    width: 100%;
    height: 75%;
    background: #ffbb00;
    border-radius: 15px;
}
.height4 {
    width: 100%;
    height: 100%;
    background: #ff0000;
    border-radius: 15px;
}
.sRect0 {
    width: 30px;
    height: 30px;
    background: #0080ff;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect1 {
    width: 30px;
    height: 30px;
    background: #0080ff;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect2 {
    width: 30px;
    height: 30px;
    background: #0bbcb2;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect3 {
    width: 30px;
    height: 30px;
    background: #ffbb00;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect4 {
    width: 30px;
    height: 30px;
    background: #ff0000;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.tRect {
    width: 15px;
    height: 15px;
    background: #fff;
    border-radius: 10px;
    margin: 0;
    position: absolute;
    top: 7.5px;
    left: 7.5px;
}
</style>
